<template>
  <section class="ui-product-list">
    <div class="list-header">
      <div class="list-header--title" v-if="is_swiper">
        {{ title }}
        <span v-if="last_update">Last Update: {{ last_update }}</span>
      </div>
      <div class="ui-search-wrap">
        <Search
          v-if="!is_swiper && show_last_datetime && store.state.user_data?.merchant_account?.is_enable_multi_brand"
          @onenter="search"
          :disabled="is_loading"
          :placeholder_text="'Search by product name or brand name'"
        />
      </div>
      <div v-if="is_swiper" class="col">
        <span class="arrow swiper-button-prev">
          <svg-icon name="arrow" />
        </span>
        <span class="arrow swiper-button-next">
          <svg-icon name="arrow" />
        </span>
      </div>
      <div class="btn-box" v-else>
        <!-- In analytics, swap this position with header's last_update (9389) -->
        <Dropdown
          v-if="can_show_checkbox && !show_last_datetime && (show_views || sortlink_data === 'shortlink')"
          :items="data_source_items"
          :direction_type="'left'"
          :icon_direction_type="'right'"
          :default_value="data_source_default_index"
          :key="sortlink_data"
          @update-dropdown="onDataSourceChange"
        />
        <Dropdown
          v-if="sort_select.length !== 0"
          :items="sort_select"
          :direction_type="'right'"
          :icon="'filter'"
          :default_value="sort_type.id"
          :key="sort_type.id"
          :is_id="true"
          @update-dropdown="updateSort"
        />
        <DatePicker v-if="show_date_picker && !is_loading" :date_range="date_range" @update-date="updateDate" />
      </div>

      <DropdownBrands
        v-if="
          is_show_brand_dropdown &&
          store.state.user_data?.merchant_account?.is_enable_multi_brand &&
          date.start &&
          date.end
        "
        @update-dropdown="updateSort"
        :start_date="date.start"
        :end_date="date.end"
        ref="brand_dropdown"
      />
      <DropdownAd
        v-if="is_all_products && !is_swiper && is_advertiser && store.state.show_advertisement && date.start && date.end"
        :start_date="date.start"
        :end_date="date.end"
        :direction_type="'right'"
        :label_text="'Advertiser'"
        :default_text="'Advertiser: all'"
      />
      <el-button
        class="the-curated-btn"
        @click="ClickCurated"
        v-if="!is_swiper && now_merchant.is_enable_storefront_curation && !is_link_only"
      >
        <Checkbox size="small" :checked="curated_check" />
        Curated only
      </el-button>

      <Dropdown
        v-if="!is_swiper"
        :items="per_page_items"
        :direction_type="'right'"
        :no_icon="true"
        :other_text="''"
        @update-dropdown="onPerPageChange"
      />
      <Pagenavi v-if="!is_swiper"  :disabled="total_page === 1" :page_current="current_page" :page_total="total_page" @goto-page="gotoPage" />
    </div>
    <p class="search-result" v-if="keyword">
      Showing results for "<span class="the-keyword">{{ capitalize(keyword) }}</span
      >"
    </p>
    <!-- add in 8882 -->
    <Loading v-if="is_loading && !data_statistic" class="static" />
    <div class="short-link" v-if="data_statistic && show_data_statistic">
      <div class="report-box" v-loading="is_loading">


        <div class="report-item" v-if="sortlink_data === 'all' || sortlink_data === 'shortlink'">
          <div class="datainfo-wrap">
            <div class="value" v-if="data_statistic.short_link_count === 0">---</div>
            <div class="value" v-else-if="data_statistic.short_link_count">
              {{ data_statistic.short_link_count.toLocaleString('en-US') }}
            </div>
            <div class="text">Shortlinks</div>
          </div>
        </div>

        <div class="report-item" v-if="show_views">
          <div class="datainfo-wrap">
            <div class="value" v-if="data_statistic.product_views_sum === 0">---</div>
            <div class="value" v-else-if="data_statistic.product_views_sum">
              {{ data_statistic.product_views_sum.toLocaleString('en-US') }}
            </div>
            <div class="text">Product Views</div>
          </div>
        </div>

        <div class="report-item">
          <SValue
            :chart_type_text="'click'"
            :is_wrap="true"
            :sum="plusData.all_click"
            :trend="data_statistic.click_trend"
            :value_text="'Clicks'"
            :show_sortlink="sortlink_data === 'all' && plusData.can_toggle_sortlink"
            :sort_value="data_statistic.short_link_click_sum"
            :store_value="data_statistic.click_sum"
          />
        </div>

        <div class="report-item">
          <SValue
            :chart_type="chart_type"
            :is_wrap="true"
            :chart_type_text="'tran'"
            :sum="plusData.all_sales"
            :trend="data_statistic.sales_trend"
            :value_text="'Sales'"
            :show_sortlink="sortlink_data === 'all' && plusData.can_toggle_sortlink"
            :sort_value="data_statistic.short_link_sales_sum"
            :store_value="data_statistic.sales_sum"
          />
        </div>

        <div class="report-item">
          <SValue
            :chart_type_text="'sales'"
            :is_wrap="true"
            :sum="Math.ceil(plusData.all_sales_value)"
            :trend="data_statistic.sales_value_trend"
            :value_text="'Sales Value'"
            :show_sortlink="sortlink_data === 'all' && plusData.can_toggle_sortlink"
            :sort_value="Math.ceil(data_statistic.short_link_sales_value_sum)"
            :store_value="Math.ceil(data_statistic.sales_value_sum)"
          />
        </div>

        <div class="report-item">
          <SValue
            :chart_type_text="'earnings'"
            :is_wrap="true"
            :sum="Math.ceil(plusData.all_earnings)"
            :trend="data_statistic.earnings_trend"
            :value_text="'Earnings'"
            :show_sortlink="sortlink_data === 'all' && plusData.can_toggle_sortlink"
            :sort_value="Math.ceil(data_statistic.short_link_earnings_sum)"
            :store_value="Math.ceil(data_statistic.earnings_sum)"
          />
        </div>
      </div>
    </div>

    <swiper
      v-if="is_swiper"
      :modules="modules"
      :slides-per-view="'auto'"
      :slides-per-group="3"
      :navigation="{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }"
    >
      <swiper-slide v-for="(item, index) in list" :key="'product-' + item.product.id">
        <ProductItem @click="open(item)" :data="item" :show_data_link="plusData.can_toggle_sortlink && sortlink_data === 'all'" />
      </swiper-slide>
    </swiper>
    <!-- table view -->
    <div v-else-if="list.length !== 0" class="products-table-view" v-loading="is_loading">
      <Scrollbar>
        <Table>
          <template #head>
            <tr :key="sort.sort_key">
              <th class="name-row"><span>Products ({{ total.toLocaleString('en-US') }})</span></th>
              <TableTh v-if="is_all_products && store.state.show_advertisement" name="advertiser_name" title="Advertiser" :sort_value="sort" @sort="sortFun" content="Advertiser" />
              <TableTh v-if="is_all_products" name="creator_count" title="Creators" :sort_value="sort" @sort="sortFun" content="Creators" />
              <TableTh v-else name="updated_at" title="Create Date" :sort_value="sort" @sort="sortFun" content="" />
              <TableTh v-if="show_views" name="views" title="Product Views" :sort_value="sort" @sort="sortFun" content="" />
              <TableTh name="click" title="Product Clicks" :sort_value="sort" @sort="sortFun" content="" />
              <TableTh name="sales" title="Sales" :sort_value="sort" @sort="sortFun" content="" />
              <TableTh name="sales_value" title="Sales Value" :sort_value="sort" @sort="sortFun" content="" />
              <TableTh name="earnings" title="Earnings" :sort_value="sort" @sort="sortFun" content="" />
            </tr>
          </template>

          <template #body>
            <tr v-for="(item, index) in list" :key="index" @click="open(item)">
              <td class="info-row">
                <div class="product-info">
                  <figure class="img-box" v-if="item.product.images">
                    <img :src="item.product.images.img_200x200" :alt="item.name"
                      @error="imageError($event)" />
                  </figure>

                  <div class="middle">
                  <div class="product-name" v-tippy="{ content: item.product.name, delay: [500, 20] }">
                      {{ item.product.name }}
                    </div>
                    <div class="brand-name">
                      {{ item.product.brand_name ? item.product.brand_name: item.brand_name? item.brand_name : '' }}
                    </div>
                    <div class="product-price">
                      {{ item.product.lowest_price }}
                    </div>
                  </div>
                </div>
              </td>

                <td v-if="is_all_products && store.state.show_advertisement">
                  <p>{{ item.advertiser_name ? item.advertiser_name : '---' }}</p>
                </td>

                <td>
                  <div class="product-creator-info">
                    <p v-if="is_all_products"><svg-icon name="users-2" /> {{ item.creator_count }}</p>
                    <p>{{ moment(item.product.created_at).format('MMM D, YYYY') }}</p>
                  </div>
                </td>

                <td v-if="!is_link_only && sortlink_data !== 'shortlink'">
                  {{ item.views ? item.views.toLocaleString('en-US') : '---' }}
                </td>

                <td>
                  {{ item.click ? item.click.toLocaleString('en-US') : '---' }}
                </td>

                <td>
                  {{item.sales ? item.sales.toLocaleString('en-US') : '---' }}
                </td>

                <td v-if="typeof item.sales_value === 'number'">
                  ${{ item.sales_value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </td>
                <td v-else>
                  ---
                </td>
                <td v-if="typeof item.earnings === 'number'">
                  ${{ item.earnings.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </td>
                <td v-else>
                  ---
                </td>
              </tr>
          </template>
        </Table>
      </Scrollbar>
    </div>


    <div class="list" v-if="!is_loading && list.length === 0">
      <NoData
        :image="require('@/assets/images/pc.png')"
        :title="no_data_context.title"
        :text="no_data_context.content"
      />
    </div>
    <Loading v-if="is_loading && is_loading_page && !is_swiper" class="static" />
  </section>
</template>

<script setup>
// Imports
import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import Dropdown from '@/components/ui/Dropdown.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import ProductItem from '@/components/product/ProductItem.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import Checkbox from '@/components/ui/Checkbox.vue';
import Table from '@/components/ui/Table.vue';
import TableTh from '@/components/ui/TableTh.vue';
import SValue from '@/components/summary/SummaryValue.vue';
import Search from '@/components/ui/Search.vue';
import DropdownBrands from '@/components/ui/DropdownBrands.vue';
import DropdownAd from '@/components/ui/DropdownAd.vue';
import { ElButton } from 'element-plus';
import { Sort_select_list } from '@/utils/SwitchFun.js';
import handleProductData from '@/utils/HandleProductData';
import 'swiper/scss';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import Scrollbar from '../ui/Scrollbar.vue';
// Props
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  is_swiper: {
    type: Boolean,
    default: false,
  },
  show_date_picker: {
    type: Boolean,
    default: false,
  },
  date_range: {
    type: Object,
    default: null,
  },
  sort_index: {
    type: Number,
    default: 0,
  },
  last_update: {
    default: '',
    type: String,
  },
  data: {
    type: Array,
    default: () => [],
  },
  is_loading: {
    type: Boolean,
    default: false,
  },
  is_loading_page: {
    type: Boolean,
    default: false,
  },
  is_show_brand_dropdown: {
    type: Boolean,
    default: false,
  },
  no_data_context: {
    type: [Object, String],
    default: '',
  },
  data_info: {
    type: Object,
    default: null,
  },
  data_statistic: {
    type: Object,
    default: null,
  },
  show_sortlink: {
    type: Boolean,
    default: false,
  },
  init_sortlink: {
    type: [Boolean, Number],
    default: undefined,
  },
  show_data_statistic: {
    type: Boolean,
    default: true,
  },
  show_last_datetime: {
    type: Boolean,
    default: false,
  },
  current_page: {
    type: Number,
    default: 1,
  },
  total_page: {
    type: Number,
    default: 1,
  },
  total: {
    type: Number,
    default: 0,
  },
  is_all_products: {
    type: Boolean,
    default: false,
  },
  sort: {
    type: Object,
    default: () => ({ key: 'views', val: 'desc' }),
  },
});

// Emits
const emit = defineEmits(['handleSortLink', 'update-sort', 'goto-page', 'update-per-page']);

// Store and instance
const store = useStore();
const instance = getCurrentInstance();
const EventBus = instance.appContext.config.globalProperties.EventBus;

// Refs
const sort_select = ref([]);

const sort_type = ref({ id: 1, text: 'Sort: Product Views (Descending)' });
const date = ref({
  start: '',
  end: '',
});

const start_watch = ref(false);
const sortlink_data = ref(props.init_sortlink !== undefined ? props.init_sortlink : (store.state.save_sortlink_data || 'all'));
const data_source_items = [
  { text: 'All Data', value: 'all' },
  { text: 'Storefront Data', value: 'storefront' },
  { text: 'Shortlinks Data', value: 'shortlink' },
];
const curated_check = ref(false);
const keyword = ref('');
const per_page_items = [
  { text: '50/page', value: 50 },
  { text: '100/page', value: 100 },
  { text: '200/page', value: 200 },
];
const advertiser_ids = ref([]);
const modules = [Navigation];
const sort = ref({
  sort_key: '',
  sort_val: 'asc',
});

// Computed
// The product in the incoming data prop may already be processed by handleProductData,
// but we re-process it here to override and avoid any omission (the function is idempotent).
const list = computed(() => {
  return props.data.map((item) => {
    if (item && item.product) {
      item.product = handleProductData(item.product);
    }
    return item;
  });
});

const data_source_default_index = computed(() => {
  return data_source_items.findIndex((item) => item.value === sortlink_data.value);
});
const plusData = computed(() => {
  let da = props.data_statistic;
  let can_toggle_sortlink = da
    ? da.short_link_click_sum + da.short_link_sales_sum + da.short_link_sales_value_sum
    : 0;

  if (!da) {
    return {
      all_click: 0,
      all_sales: 0,
      all_sales_value: 0,
      all_earnings: 0,
      can_toggle_sortlink: can_toggle_sortlink,
    };
  }
  if (sortlink_data.value === 'all') {
    return {
      all_click: da.click_sum + da.short_link_click_sum,
      all_sales: da.sales_sum + da.short_link_sales_sum,
      all_sales_value: Math.ceil(da.sales_value_sum) + Math.ceil(da.short_link_sales_value_sum),
      all_earnings: Math.ceil(da.earnings_sum) + Math.ceil(da.short_link_earnings_sum),
      can_toggle_sortlink: can_toggle_sortlink,
    };
  } else if (sortlink_data.value === 'shortlink') {
    return {
      all_click: da.short_link_click_sum,
      all_sales: da.short_link_sales_sum,
      all_sales_value: Math.ceil(da.short_link_sales_value_sum),
      all_earnings: Math.ceil(da.short_link_earnings_sum),
      can_toggle_sortlink: can_toggle_sortlink,
    };
  } else {
    return {
      all_click: da.click_sum,
      all_sales: da.sales_sum,
      all_sales_value: da.sales_value_sum,
      all_earnings: da.earnings_sum,
      can_toggle_sortlink: can_toggle_sortlink,
    };
  }
});

const can_show_checkbox = ref(true);

// const can_show_checkbox = computed(() => {
//   return start_watch.value && props.data_statistic && plusData.value.can_toggle_sortlink && props.show_sortlink;
// });

const permission_creator = computed(() => {
  return store.state.user_data?.permission_list?.creatorManagement;
});

const now_merchant = computed(() => {
  return store.state.user_data.merchant_account;
});

const is_link_only = computed(() => {
  return store.state.user_data?.merchant_account.platform_type === 'linkonly';
});

const has_historical_storefront_tracking = computed(() => {
  if (store.state.list_has_historical_storefront_tracking) {
    return props.data_info?.views;
  }
  return false;
});

const show_views = computed(() => {
  if (sortlink_data.value === 'shortlink') return false;
  if (!props.data_info) {
    return !is_link_only.value || (is_link_only.value && store.state.list_has_historical_storefront_tracking);
  }
  const creator_was_storefront = props.data_info.platform_type === 'storefront' || props.data_info.views;
  if ((!is_link_only.value && creator_was_storefront) ||
    (is_link_only.value && has_historical_storefront_tracking.value)
    ) {
    return true;
  }
  return false
});

const is_advertiser = computed(() => {
  return true;
});

const is_cj= computed(() => {
  return store.state.projectName === 'cj';
});
//+++++++++++++++++++++++++++++++
// Methods
//++++++++++++++++++++++++++++++++
const imageError = (e) => {
  e.target.style.display = 'none';
};

const capitalize = (word) => {
  if (!word) return '';
  return word.charAt(0).toUpperCase() + word.slice(1);
};

const gotoPage = (page) => {
  emit('goto-page', page);
};

const onPerPageChange = (item) => {
  emit('update-per-page', item.value);
};

const onAdvertisersChange = (advertisers) => {
  advertiser_ids.value = advertisers.map((item) => item.id);
  fieldFunction();
};

const onDataSourceChange = (item) => {
  sortlink_data.value = item.value;
  emit('handleSortLink', item.value);
};

const updateDate = (obj) => {
  date.value.start = moment(obj.start_date).format('YYYY-MM-DD');
  date.value.end = moment(obj.end_date).format('YYYY-MM-DD');
  fieldFunction();
};

const updateSort = (id) => {
  sort_type.value = id;
  date.value.start = moment(props.date_range.start_date).format('YYYY-MM-DD');
  date.value.end = moment(props.date_range.end_date).format('YYYY-MM-DD');
  
  // base on id to set sort
  const sortMapping = {
    1: { key: 'views', val: 'desc' },
    2: { key: 'views', val: 'asc' },
    3: { key: 'clicks', val: 'desc' },
    4: { key: 'clicks', val: 'asc' },
    5: { key: 'sales', val: 'desc' },
    6: { key: 'sales', val: 'asc' },
    7: { key: 'sales_value', val: 'desc' },
    8: { key: 'sales_value', val: 'asc' },
    21: { key: 'earnings', val: 'desc' },
    22: { key: 'earnings', val: 'asc' },
    23: { key: 'creator_count', val: 'desc' },
    24: { key: 'creator_count', val: 'asc' },
    25: { key: 'updated_at', val: 'desc' },
    26: { key: 'updated_at', val: 'asc' },
    27: { key: 'advertiser_name', val: 'asc' },
    28: { key: 'advertiser_name', val: 'desc' },
  };

  // console.log('sortMapping[id.id]', sortMapping[id.id]);
  
  if (sortMapping[id.id]) {
    sort.value = {
      sort_key: sortMapping[id.id].key,
      sort_val: sortMapping[id.id].val,
    };
  }
  
  fieldFunction();
};

const open = (data) => {
  date.value.start = moment(props.date_range.start_date).format('YYYY-MM-DD');
  date.value.end = moment(props.date_range.end_date).format('YYYY-MM-DD');
  let d = {
    product_id: data.id,
    start_date: date.value.start,
    end_date: date.value.end,
    init_sortlink: sortlink_data.value,
  };
  if (props.data_info) d.data_info = props.data_info;
  EventBus.emit('open-product-modal', d);
};

const fieldFunction = () => {
  let obj = {
    type: sort_type.value,
    date: {
      start: date.value.start,
      end: date.value.end,
    },
    keyword: keyword.value,
    curated_check: curated_check.value,
    advertiser_ids: advertiser_ids.value,
  };
  emit('update-sort', obj);
};

const ClickCurated = () => {
  curated_check.value = !curated_check.value;
  fieldFunction();
};

const search = (searchKeyword) => {
  keyword.value = searchKeyword;
  fieldFunction();
};

const sortFun = (columnName) => {
  // If clicking the same column, toggle sort direction
  if (sort.value.sort_key === columnName) {
    sort.value.sort_val = sort.value.sort_val === 'asc' ? 'desc' : 'asc';
  } else {
    // Clicking new column, default to descending
    sort.value.sort_key = columnName;
    sort.value.sort_val = 'desc';
  }
  
  // Synchronize dropdown selection
  const sortToDropdown = {
    'views_desc': 1,
    'views_asc': 2,
    'clicks_desc': 3,
    'clicks_asc': 4,
    'sales_desc': 5,
    'sales_asc': 6,
    'sales_value_desc': 7,
    'sales_value_asc': 8,
    'earnings_desc': 21,
    'earnings_asc': 22,
    'creator_count_desc': 23,
    'creator_count_asc': 24,
    'updated_at_desc': 25,
    'updated_at_asc': 26,
    'advertiser_name_asc': 27,
    'advertiser_name_desc': 28,
  };
  
  const dropdownKey = `${sort.value.sort_key}_${sort.value.sort_val}`;
  const dropdownId = sortToDropdown[dropdownKey];

  if (dropdownId) {
    sort_type.value = sort_select.value.find(item => item.id === dropdownId);
    // console.log('Synchronized dropdown to:', sort_type.value);
  }
  
  fieldFunction();
};

// Lifecycle
onMounted(() => {
  date.value.start = moment(props.date_range.start_date).format('YYYY-MM-DD');
  date.value.end = moment(props.date_range.end_date).format('YYYY-MM-DD');

  start_watch.value = true;
  
  // Filter sort_select based on is_all_products
  if (props.is_all_products) {
    // Show creator_count options, hide updated_at options
    sort_select.value = Sort_select_list.filter(item => item.id !== 25 && item.id !== 26);
    // Advertiser sort options are only available for the cj project
    if (store.state.show_advertisement) {
      sort_select.value.push({ id: 27, text: 'Sort: Advertiser Name (A-Z)', keyword: 'advertiser_name' });
      sort_select.value.push({ id: 28, text: 'Sort: Advertiser Name (Z-A)', keyword: 'advertiser_name' });
    }
  } else {
    // Show updated_at options, hide creator_count options
    sort_select.value = Sort_select_list.filter(item => item.id !== 23 && item.id !== 24);
  }

  sort.value = props.sort;

  EventBus.on('update-by-ad', onAdvertisersChange);
});

onUnmounted(() => {
  EventBus.off('update-by-ad', onAdvertisersChange);
});
</script>
<style lang="scss">
.ui-product-list {
  position: relative;
  width: 100%;

  .search-result {
    margin-right: 8px;
    padding: 6px 10px;
    background: var(--bg-02);
    border: 1px solid var(--neutral);
    border-radius: 100px;
    color: var(--black-90);
    font: var(--font-med-12);
    margin-bottom: 16px;
    display: inline-block;
  }

  .list-header {
    display: flex;
    align-items: center;
    gap: 8px;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
    padding-top: 16px;
    padding-bottom: 16px;

    .list-header--title {
      font: var(--font-demi-20);
      display: flex;
      align-items: center;
      color: var(--black-90);

      span {
        margin-left: 16px;
        font: var(--font-fg-12);
      }
    }

    .ui-search-wrap {
      flex: 1;

      .ui-search-input .input {
        max-width: unset;
      }
    }

    .col {
      display: flex;
      align-items: center;

      span {
        height: 24px;
        width: 24px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-left: 10px;
        border-radius: 2px;
        transition: all 0.2s ease-in-out;
        color: var(--black-90);

        &:hover {
          background-color: var(--bg-03);
        }

        svg {
          height: 10px;
          width: 10px;
          position: relative;
          transform: rotate(90deg);
        }

        &.swiper-button-next {
          svg {
            transform: rotate(-90deg);
          }
        }

        &.swiper-button-disabled {
          cursor: not-allowed;
          color: var(--black-40);
          pointer-events: none;
        }
      }
    }

    .btn-box {
      display: flex;
      align-items: center;
      cursor: pointer;
      gap: 8px;

      time {
        font-size: 12px;
        color: var(--black-75);
        padding-right: 12px;
        margin-left: 8px;
      }
    }
  }

  .tbody tr {
    cursor: pointer;
  }

  .report-box {
    margin: 0 0 16px 0;
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.08);

    &.is-loading {
      opacity: 0.3;
    }

    .report-item {
      padding: 12px;
      width: 25%;
      background: white;
      border-right: 1px solid rgba(0, 0, 0, 0.08);
      align-content: center;

      .datainfo-wrap {
          .text {
            font:var(--font-med-14);
            color: var(--text-secondary);
            margin-bottom: 4px;
          }

          .desc-text{
            font:var(--font-med-12);
          }
          .value {
            font: var(--font-med-20);
            color: var(--dark-blue);
          }
      }


      .the-type {
        width: 100%;
        padding: 0;
        border: none;
      }

      &:last-child {
        border-right: none;
      }
    }
  }

  .loading {
    margin-top: 20px;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -4px;

    .product-item {
      width: calc(25% - 8px);
      display: block;
      margin: 4px;
    }
  }

  .swiper-wrapper {
    display: flex;

    .swiper-slide {
      width: 236px;
      padding: 0 8px;
      box-sizing: content-box;

      &:last-child {
        padding-right: 0;
      }

      &:first-child {
        padding-left: 0;
      }
    }
  }

  .update-time {
    cursor: auto;
  }

  .the-curated-btn {
    border-color: var(--border);
    color: var(--black-60);
    font-size: 12px;
    padding-left: 9px;
    padding-right: 9px;
  }
}

.products-table-view {
  .product-info {
    display: flex;
    align-items: center;
    gap: 12px;
    max-width: 380px;
    overflow: hidden;

    .img-box {
      position: relative;
      width: 100px;
      height: 100px;
      min-width: 100px;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }

    .middle {
      color: var(--black-90);
      // min-height: 100%;
      // display: flex;
      // flex-direction: column;

      .product-name {
        width: 100%;
        font: var(--font-demi-14);
        margin-right: 11px;
        display: flex;
        align-items: flex-start;
        gap: 4px;

        .product-name-text {
          flex: 1;
          min-width: 0;
          display: -webkit-box;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          white-space: break-spaces;
        }

        .product-link {
          flex-shrink: 0;
          color: var(--black-60);
          position: relative;
          top: 3px;

          &:hover {
            color: var(--Blue-30);
          }

          svg {
            width: 12px;
            height: 12px;
          }
        }
      }

      .brand-name {
        font: var(--font-med-12);
        color: var(--black-75);
        flex: 1;
      }

      .product-price {
        font: var(--font-med-12);
        margin-top: 8px;
      }
    }
  }

  .product-creator-info {
    p {
      font-size: 12px;
      white-space: nowrap;

      &:nth-child(1) {
        display: flex;
        align-items: center;
        gap: 4px;

        svg {
          width: 14px;
          height: 14px;
        }
      }

      &:nth-child(2) {
        margin: 8px 0;
      }
    }
  }
}
</style>
